import React from "react";
import "./NewTradingHistory.scss";

const TradeDetailsCard = ({ trade }) => {
  console.log(trade, 'tradeDetails');

  const netProfit = trade?.profit - trade?.commission;

  const formatCurrency = (value) => {
    return Number(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <div className="trade-card-info">
      <div className="trade-summary">
        <div className="trade-summary-row">
          <div><strong>Deal ID</strong>{trade?.deal_id}</div>
          <div>
            <strong>Date & Time</strong>
            {new Date(trade?.date).toLocaleString('en-US', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
              timeZone: 'UTC'
            })}
          </div>
          <div><strong>Volume</strong>{trade?.volume}</div>
          <div><strong>Symbol</strong>{trade?.symbol}</div>
          <div>
            <strong>Profit</strong>
            <span style={{color:trade?.profit >= 0 ? "#4caf50" : "#f44336"}} className={trade?.profit >= 0 ? "profit-positive" : "profit-negative"}>
              ${formatCurrency(trade?.profit)}
            </span>
          </div>
          <div><strong>Side</strong>{trade?.trade_side}</div>
        </div>
      </div>

      <div className="trade-details">
        <div className="trade-section">
          <h4>Price</h4>
          <p><strong>Type:</strong> {trade?.trade_side}</p>
          <p><strong>Price:</strong> {trade?.price}</p>
        </div>

        <div className="trade-section">
          <h4>Trade Protection</h4>
          <p><strong>Stop Loss:</strong> {trade?.stop_loss}</p>
          <p><strong>Take Profit:</strong> {trade?.take_profit}</p>
        </div>

        <div className="trade-section">
          <h4>Results</h4>
          <p>
            <strong>Profit:</strong>{" "}
            <span style={{color:trade?.profit >= 0 ? "#4caf50" : "#f44336"}} className={trade?.profit >= 0 ? "profit-positive" : "profit-negative"}>
              ${formatCurrency(trade?.profit)}
            </span>
          </p>
          <p><strong>Commission:</strong> ${formatCurrency(trade?.commission)}</p>
          <p>
            <strong>Net Profit:</strong>{" "}
            <span style={{color:netProfit >= 0 ? "#4caf50" : "#f44336"}} className={netProfit >= 0 ? "profit-positive" : "profit-negative"}>
              ${formatCurrency(netProfit)}
            </span>
          </p>
        </div>

        <div className="trade-section">
          <h4>Info</h4>
          <p><strong>Deal Status:</strong> {trade?.deal_status}</p>
          <p><strong>Lot Size:</strong> ${formatCurrency(trade?.lot_size)}</p>
          <p><strong>Position ID:</strong> {trade?.position}</p>
        </div>
      </div>
    </div>
  );
};

export default TradeDetailsCard;
